import { useQuery } from "@tanstack/react-query"

import {
  createReminder,
  deleteReminder,
  editReminder,
  getReminderMeta,
  getReminders,
} from "api/reminderApi"
import {
  useCreateResource,
  useDeleteResource,
  useEditResource,
  usePaginatedResource,
} from "./useCrudResource"

export const REMINDER_QUERY_KEY = "reminders"

export const useReminders = (params = {}, enabled = true) =>
  usePaginatedResource(REMINDER_QUERY_KEY, getReminders, params, enabled)

export const useReminderMeta = (enabled = true) =>
  useQuery({
    queryKey: [REMINDER_QUERY_KEY, "meta"],
    queryFn: getReminderMeta,
    enabled,
    staleTime: 10 * 60 * 1000,
  })

export const useCreateReminder = () =>
  useCreateResource(createReminder, REMINDER_QUERY_KEY)

export const useEditReminder = () =>
  useEditResource(editReminder, REMINDER_QUERY_KEY)

export const useDeleteReminder = () =>
  useDeleteResource(deleteReminder, REMINDER_QUERY_KEY)
